import React, { PureComponent } from 'react';
import { v1 as uuidv1 } from 'uuid';
import ReactTooltip from 'react-tooltip';

import styles from './copyToClipboard.scss';

class CopyToClipboard extends PureComponent {
    render() {
        const { text, className, 'data-testid': dataTestId } = this.props;
        const copyToClipboard = () => {
            navigator.clipboard.writeText(text);
        };

        const uuid = uuidv1();

        return (
            <>
                <div
                    className={`${styles.copyToClipboard} ${className}`}
                    data-tip="Copied"
                    data-for={uuid}
                    data-testid={dataTestId}
                >
                    <span className={styles.text} data-testid={dataTestId && `${dataTestId}.text`}>{text}</span><span className={styles.copy}><i className="far fa-copy ml8" /></span>
                </div>
                <ReactTooltip
                    id={uuid}
                    event="click"
                    eventOff="mouseout"
                    afterShow={copyToClipboard}
                />
            </>
        );
    }
}

export default CopyToClipboard;
